import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { useContext, useEffect, useRef } from "react";

import { Template } from "features/Influencer/ContactList/schema";

/** Registers a Save-as-New swap; `onSwap` receives the new template and the edited template's id. */
export function useRegisterSaveAsNew(
  onSwap: (newTemplate: Template, editedId: number) => void,
  enabled: boolean = true,
) {
  const { setOnSaveAsNew, editTemplateDialogId } = useContext(
    OutreachTemplatesContext,
  );
  const editIdRef = useRef(editTemplateDialogId);
  editIdRef.current = editTemplateDialogId;
  const swapRef = useRef(onSwap);
  swapRef.current = onSwap;

  useEffect(() => {
    if (!enabled) return;
    setOnSaveAsNew(
      () => (newTemplate: Template) =>
        swapRef.current(newTemplate, Number(editIdRef.current)),
    );
    return () => setOnSaveAsNew(null);
  }, [setOnSaveAsNew, enabled]);
}
